import { Elm } from './app/Main.elm';

const app = Elm.Main.init({
  node: document.getElementById('app'),
});
